import React, { useEffect, useRef } from 'react';

import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';

import { cancelPublicScheduled } from 'api/endpoints/survey';
import Button from 'components/Button';
import { TEXT_COMMON, TEXT_CREATE_SURVEY } from 'constants/string/texts';
import { toastError, toastSuccess } from 'lib/toast';
import { setOpenCancelSchedule } from 'store/actions/survey';

const ExclamationCircle2 = require('assets/resources/ExclamationCircle2.svg').default;

const Modal = () => {
  const modalRef = useRef(null);
  const dispatch = useDispatch();
  const { isOpen, id, callBack } = useSelector((state) => state.survey.openCancelSchedule);

  const closeModal = () => {
    dispatch(setOpenCancelSchedule({ isOpen: false, id: null }));
  };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('h-screen');
    } else {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('h-screen');
    }
  }, [isOpen]);

  const onConfirm = async () => {
    await cancelPublicScheduled(id)
      .then(async (result) => {
        toastSuccess(result.message);
        await callBack?.();
        closeModal();
      })
      .catch((error) => {
        toastError(error.message);
        closeModal();
      });
  };

  const clickBackdrop = () => {
    modalRef.current.classList.add('animate-fade-out');
    setTimeout(() => {
      modalRef.current.classList.remove('animate-fade-out');
    }, 300);
  };

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div data-testid="modal" id="modal" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-max">
      <div id="backdrop-modal" onClick={clickBackdrop} className="fixed inset-0 backdrop" />

      <div ref={modalRef} className={'bg-white rounded-sm shadow-lg p-8 pb-6 relative max-w-104 w-full modal-content'}>
        <div data-testid="header-modal" id="header-modal" className="flex items-start">
          <div className="text-orange-500 mr-2 text-2xl min-w-6 min-h-6">
            <img src={ExclamationCircle2} alt="exclamation" width={22} height={22} />
          </div>
          <h2 className="text-base font-bold text-logo">{TEXT_CREATE_SURVEY.CANCEL_SCHEDULE_CONFIRM_TITLE}</h2>
        </div>

        <div data-testid="footer-modal" id="footer-modal" className="mt-6 flex justify-end gap-2">
          <Button onClick={closeModal} text={TEXT_COMMON.CANCEL_TEXT} color="outline" className="w-25.5 px-3.75 h-8 text-sm text-black/85" />
          <Button
            onClick={onConfirm}
            text={TEXT_CREATE_SURVEY.CANCEL_SCHEDULE_CONFIRM}
            color="primary"
            className={'w-22 h-8 px-3.75 text-sm border border-solid border-primary-423'}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default React.memo(Modal);
